import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BibStyle } from '../rl-common/shared/shared/types/bib-style';

@Injectable({
  providedIn: 'root'
})
export class FormatService {

  constructor(private http: HttpClient) { }

  quickCite = (citationId : string, params : {lang : string, style : string}): Observable<string> => this.http.get(`../rl/main/${citationId}/quickCite`, {params : params, responseType: 'text'});
  bibStylesWithDefault = () : Observable<BibStyle[]> => this.http.get<BibStyle[]>(`../rl/files/wordBibStylesWithDefault`);

}
